import React from 'react';
import { Search } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/search.less';

export default Search;
